import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
} from '@mui/material';
import ParametersPanel from './ParametersPanel';

const ParametersDialog = ({ open, onClose, t, unitOptions, rankOptions, yearOptions, settings, dispatch }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>{t('estimationPage.parametersDialogTitle') || 'Parameters'}</DialogTitle>
      <DialogContent>
        <ParametersPanel
          t={t}
          unitOptions={unitOptions}
          rankOptions={rankOptions}
          yearOptions={yearOptions}
          filters={settings.filters}
          bootstrap={settings.bootstrap}
          showChart={settings.chart?.showChart}
          onShowChartChange={(value) => dispatch({ type: 'setChart', payload: { showChart: value } })}
          onUnitChange={(value) => dispatch({ type: 'setFilters', payload: { unitFilter: value } })}
          onRankChange={(value) => dispatch({ type: 'setFilters', payload: { rankFilter: value } })}
          onConceptChange={(value) => dispatch({ type: 'setFilters', payload: { conceptUnit: value } })}
          onStatusChange={(value) => dispatch({ type: 'setFilters', payload: { statusFilter: value } })}
          onContextChange={(value) => dispatch({ type: 'setFilters', payload: { contextFilter: value } })}
          onBootstrapChange={(event) => dispatch({ type: 'setBootstrap', payload: { bootstrapSamples: Number(event.target.value) } })}
          onCurveBandToggle={(event) => dispatch({ type: 'setBootstrap', payload: { curveBandEnabled: event.target.checked } })}
          onRandomSeedChange={(event) => dispatch({ type: 'setBootstrap', payload: { randomSeed: event.target.value } })}
          onCurveFitMethodChange={(value) => dispatch({ type: 'setBootstrap', payload: { curveFitMethod: value } })}
          onStartYearChange={(value) => dispatch({ type: 'setFilters', payload: { startYear: value } })}
          onEndYearChange={(value) => dispatch({ type: 'setFilters', payload: { endYear: value } })}
          onSaveSettings={() => {
            try {
              localStorage.setItem('TSE_settings_v1', JSON.stringify(settings));
              // eslint-disable-next-line no-alert
              window.alert(t('estimationPage.settingsSaved') || 'Settings saved locally');
            } catch (err) {
              // eslint-disable-next-line no-alert
              window.alert(t('estimationPage.settingsSaveFailed') || 'Save failed');
              // eslint-disable-next-line no-console
              console.error(err);
            }
          }}
          onResetSettings={() => {
            // eslint-disable-next-line no-alert
            if (window.confirm(t('estimationPage.resetConfirm') || 'Reset settings to defaults?')) {
              dispatch({ type: 'resetSettings' });
              localStorage.removeItem('TSE_settings_v1');
            }
          }}
          onShareSettings={() => {
            try {
              const encoded = btoa(JSON.stringify(settings));
              const url = `${window.location.origin}${window.location.pathname}?tse=${encodeURIComponent(encoded)}`;
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(() => {
                  // eslint-disable-next-line no-alert
                  window.alert(t('estimationPage.settingsCopied') || 'Share URL copied to clipboard');
                });
              } else {
                // eslint-disable-next-line no-alert
                window.prompt(t('estimationPage.copySharePrompt') || 'Copy this URL', url);
              }
            } catch (err) {
              // eslint-disable-next-line no-alert
              window.alert(t('estimationPage.settingsCopyFailed') || 'Failed to create shareable URL');
              // eslint-disable-next-line no-console
              console.error(err);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('estimationPage.parametersDialogCancel') || 'Cancel'}</Button>
        <Button
          variant="contained"
          onClick={() => {
            dispatch({ type: 'triggerRun' });
            onClose();
          }}
        >
          {t('estimationPage.parametersDialogRun') || 'Run calculation'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ParametersDialog;
